import { render, staticRenderFns } from "./ConfirmAddStake.vue?vue&type=template&id=7aeac5d9&lang=pug"
import script from "./ConfirmAddStake.vue?vue&type=script&lang=js"
export * from "./ConfirmAddStake.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports